<template>
  <!--begin::List Widget 9-->
  <div class="card card-custom card-stretch gutter-b">
    <!--begin::Header-->
    <div class="card-header align-items-center border-0 mt-4">
      <h3 class="card-title align-items-start flex-column">
        <span class="font-weight-bolder text-dark"> Recent Activities </span>
        <span class="text-muted mt-3 font-weight-bold font-size-sm">
          {{momentCount}} Moments Total
        </span>
      </h3>

    </div>
    <!--end::Header-->


    <!--begin::Body-->
    <div class="card-body pt-4">
      <div class="timeline timeline-6 mt-3">
        <template v-for="(item, i) in logFilter(recentLogs)">
          <!--begin::Item-->
          <div class="timeline-item align-items-start" v-if="i < 7"  v-bind:key="'log-' + i">
            <!--begin::Label-->

            <!--end::Label-->

            <!--begin::Badge-->
            <div class="timeline-badge">
              <i class="icon-xxl fa fa-genderless" v-bind:class=" item.error ? 'text-danger' : 'text-success'"></i>
            </div>
            <!--end::Badge-->

            <!--begin::Text-->
            <div
              class="font-weight-mormal font-size-sm timeline-content text-muted pl-0"
            >
              <span v-html="item.message"></span><span class="pl-1">({{ formatDate(item.created_at.seconds) }})</span>

            </div>
            <!--end::Text-->
          </div>
          <!--end::Item-->
        </template>
      </div>
      <!--end: Items-->
    </div>
    <!--end: Card Body-->
  </div>
  <!--end: Card-->
  <!--end: List Widget 9-->
</template>
<style>
.timeline.timeline-6:before {
  left: 0px!important;
}
</style>
<script>
import { mapGetters } from "vuex";

export default {
  name: "widget-9",
  data() {
    return {
      list: [
        {
          created_at: {seconds: 1682508121},
          message: "New delivery",
          action: true,
          error: false,
        },
        {
          created_at: {seconds: 1682508121},
          message: "Failed delivery Creation",
          action: false,
          error: true,
        },
      ],
    };
  },
  methods: {
    logFilter(logs) {
      if (logs != null) {
        return logs.filter(v => v.action || v.error);
      }
      return [];
    },
    formatDate(timestamp) {

      const currentDate = new Date();
      const timestampDate = new Date(timestamp * 1000); // Convert seconds to milliseconds

      const timeDifferenceInMinutes = Math.floor((currentDate - timestampDate) / (1000 * 60));
      const timeDifferenceInHours = Math.floor(timeDifferenceInMinutes / 60);
      const timeDifferenceInDays = Math.floor(timeDifferenceInHours / 24);
      const timeDifferenceInMonths = Math.floor(timeDifferenceInDays / 31);

      if (timeDifferenceInMonths != 0) {
        return `${timeDifferenceInMonths} months ago`;
      } else if (timeDifferenceInDays != 0) {
        return `${timeDifferenceInDays} days ago`;
      }  else if (timeDifferenceInHours != 0) {
        return `${timeDifferenceInHours} hours ago`;
      } else if (timeDifferenceInMinutes != 0) {
        return `${timeDifferenceInMinutes} minutes ago`;
      } else {
        return 'seconds ago';
      }

    }
  },
  computed: {
    ...mapGetters(["recentLogs", "momentCount"]),
  },
};
</script>
